export default {"src":"/login-app/[GIT_HASH]/_next/static/media/organization.9f5b6cf1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};